export default function Testimonials() {
  const testimonials = [
    {
      company: '建設業 A社',
      industry: '神奈川県・従業員15名',
      text: '補助金を活用しながら設備導入し、LP制作まで行った結果、問い合わせが2.3倍になりました。補助金と集客を同時に考えてくれる会社は他になく、本当に助かっています。',
      name: '代表取締役',
      avatar: 'ri-user-3-fill',
      rating: 5
    },
    {
      company: '美容サロン B社',
      industry: '東京都・従業員8名',
      text: '内容証明と補助金申請をまとめて任せられたことで、経営上のリスクと負担が大幅に減りました。法務と補助金を一緒に相談できるのは本当に便利です。',
      name: '経営者',
      avatar: 'ri-user-smile-fill',
      rating: 5
    },
    {
      company: 'IT企業 C社',
      industry: '神奈川県・従業員20名',
      text: '成功報酬が他社より圧倒的に安く、継続的に補助金を活用できています。顧問契約で法務相談もできるので、契約書のチェックなども気軽に依頼できて安心です。',
      name: '取締役',
      avatar: 'ri-user-star-fill',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            お客様の<span className="text-blue-900">導入実例</span>
          </h3>
          <p className="text-lg text-gray-600">実際にご利用いただいている企業様の声</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center">
                  <i className={`${testimonial.avatar} text-white text-2xl`}></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.company}</h4>
                  <p className="text-sm text-gray-600">{testimonial.industry}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                「{testimonial.text}」
              </p>

              <div className="text-right text-sm text-gray-600">
                ー {testimonial.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
